export default {
  ["agent_admin"]: `代理后台`,
  ["edit_pwd"]: `修改密码`,
  ["logout"]: `登出`,
  ["login"]: `登录`,
  ["register"]: `注册`,
  ["dashboard"]: `仪表盘`,
  ["registration"]: `注册链接`,
  ["incomes"]: `分红`,
  ["record"]: `记录`,
  ["rules"]: `规则`,
  ["account"]: `账号`,
  ["account_ph"]: `请输入正确的账号`,
  ["password"]: `密码`,
  ["password_ph"]: `请输入正确的密码`,
  ["remember_account"]: `记住账号`,
  ["invite_ratio"]: `邀请玩家获得`,
  ["invite_ratio_desc"]: `净结算盈亏`,
  ["product_fee_ratio"]: `产品手续费`,
  ["product_fee_ratio_desc"]: `净结算盈亏`,
  ["register_count"]: `注册人数`,
  ["login_count"]: `登录人数`,
  ["deposit_count"]: `充值人数`,
  ["first_deposit_count"]: `首充人数`,
  ["deposit_amount"]: `充值金额`,
  ["withdraw_amount"]: `提现金额`,
  ["valid_bet_amount"]: `有效投注金额`,
  ["win_amount"]: `中奖金额`,
  ["bonus_amount"]: `活动奖金`,
  ["profit_amount"]: `总盈亏`,
  ["link_manage"]: `链接管理`,
  ["add_link"]: `新增链接`,
  ["link_reached_limit"]: `链接数到达上限`,
  ["copy_success"]: `复制成功`,
  ["submit"]: `提交`,
  ["cancel"]: `取消`,
  ["download"]: `下载`,
  ["sub_domain"]: `子域名`,
  ["sub_domain_ph"]: `请输入正确的子域名`,
  ["tag_name"]: `标签名`,
  ["tag_name_ph"]: `请输入正确的标签名`,
  ["link_status_0"]: `无状态`,
  ["link_status_1"]: `初始化中`,
  ["link_status_2"]: `已生效`,
  ["link_status_3"]: `可重试`,
  ["link_sttaus_4"]: `不可用`,
  ["month"]: `月份`,
  ["active_user_count"]: `活跃用户数量`,
  ["product_fee_amount"]: `产品手续费`,
  ["dividend_ratio"]: `费率比例`,
  ["dividend_amount"]: `佣金`,
  ["status"]: `状态`,
  ["dividend_bill_status_0"]: `进行中`,
  ["dividend_bill_status_4"]: `待结算`,
  ["dividend_bill_status_9"]: `已结算`,
  ["month_phase_1"]: `上半月`,
  ["month_phase_2"]: `下半月`,
  ["click_here"]: `点击这里`,
  ["click_here_desc"]: `联系你的账号管理员去进行USDT提现`,
  ["available_commission"]: `可获得分红`,
  ["time"]: `日期`,
  ["affiliate_program"]: `联盟计划`,
  ["active_user_desc"]: `活跃用户说明`,
  ["payout_instructions"]: `结算说明`,
  ["payout_instructions_detail"]: `说明1</br>说明2</br>说明3`,
  ["rules_detail"]: `1.规则1</br>2.规则2</br>3.规则3`,
  ["get_withdraw"]: `获取分红`,
  ["commission_history"]: `分红历史记录`,
  ["link_capacity"]: `可创建链接`,
  ["language"]: `语言`,
  ["old_password"]: `旧密码`,
  ["old_password_ph"]: `请输入旧密码`,
  ["new_password"]: `新密码`,
  ["new_password_ph"]: `请输入新密码`,
  ["confirm_password"]: `确认密码`,
  ["confirm_password_ph"]: `请确认密码`,
  ["confirm_password_not_same"]: `确认密码输入不一致`,
  ["operation_success"]: `操作成功`,
  ["need_change_pwd_title"]: `账号需要修改密码`,
  ["need_change_pwd_content"]: `账号需要修改密码`,
  ["need_change_pwd_confirm"]: `去修改`,
  ["err_5001"]: `内部错误 加锁失败`,
  ["err_5002"]: `内部错误 加锁冲突`,
  ["err_5003"]: `参数错误`,
  ["err_6001"]: `被封禁登录失败`,
  ["err_6003"]: `链接到上限没法添加，重复创建相同的链接`,
  ["err_6004"]: `创建链接时发生冲突`,
  ["err_2003"]: `密码无效`,
  ["err_2014"]: `用户名无效`,
  ["err_1303"]: `旧密码输入错误`,
  ["err_1308"]: `新密码与当前密码相同`,
  ["date_picker_today"]: `今天`,
  ["date_picker_yesterday"]: `昨天`,
  ["date_picker_7_days"]: `最近7天`,
  ["date_picker_30_days"]: `最近30天`,
  ["date_picker_this_month"]: `本月`,
  ["select_date_range"]: `请选择日期`,
  ["date_picker_ok"]: `OK`,
  ["start_date"]: `开始日期`,
  ["end_date"]: `结束日期`,
  ["date_picker_year"]: `年`,
  ["date_picker_month"]: `月`,
  ["date_picker_day"]: `日`,
}